import type { RefObject } from 'react';
import { useContext, useEffect } from 'react';

import { DndContext } from '../context/dnd-context';

import { useDraggablePortalRoot } from './use-draggable-portal-root';

export function useDndContext({ draggableContainerClassName }: UseDndContext.Args): UseDndContext.Return {
  const { containerRef, setDraggableContainer, setContainerRect } = useContext(DndContext);

  useDraggablePortalRoot('draggable-container', setDraggableContainer, draggableContainerClassName);

  useEffect(() => {
    const element = containerRef.current;

    const resizeObserver = new ResizeObserver(() => {
      if (element) {
        const elementRect = element.getBoundingClientRect();

        setContainerRect(elementRect);
      } else {
        setContainerRect(null);
      }
    });

    if (element) {
      resizeObserver.observe(element);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [containerRef, setContainerRect]);

  return containerRef;
}

export namespace UseDndContext {
  export type Args = {
    draggableContainerClassName?: string;
  };

  export type Return = RefObject<HTMLDivElement>;
}
